
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_1q0fm_185",
  "arrow-outer": "awsui_arrow-outer_xjuzf_1q0fm_189",
  "arrow-inner": "awsui_arrow-inner_xjuzf_1q0fm_189",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_1q0fm_220",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_1q0fm_220",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_1q0fm_223",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_1q0fm_223",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_1q0fm_226",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_1q0fm_226",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_1q0fm_226",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_1q0fm_226",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_1q0fm_229",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_1q0fm_229",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_1q0fm_229",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_1q0fm_229",
  "body": "awsui_body_xjuzf_1q0fm_325",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_1q0fm_344",
  "variant-annotation": "awsui_variant-annotation_xjuzf_1q0fm_348",
  "body-size-small": "awsui_body-size-small_xjuzf_1q0fm_353",
  "fixed-width": "awsui_fixed-width_xjuzf_1q0fm_356",
  "body-size-medium": "awsui_body-size-medium_xjuzf_1q0fm_360",
  "body-size-large": "awsui_body-size-large_xjuzf_1q0fm_367",
  "has-dismiss": "awsui_has-dismiss_xjuzf_1q0fm_374",
  "dismiss": "awsui_dismiss_xjuzf_1q0fm_379",
  "dismiss-control": "awsui_dismiss-control_xjuzf_1q0fm_386",
  "header-row": "awsui_header-row_xjuzf_1q0fm_390",
  "header": "awsui_header_xjuzf_1q0fm_390",
  "content": "awsui_content_xjuzf_1q0fm_412",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_1q0fm_419",
  "container": "awsui_container_xjuzf_1q0fm_431",
  "container-arrow": "awsui_container-arrow_xjuzf_1q0fm_439",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_1q0fm_443",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_1q0fm_443",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_1q0fm_455",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_1q0fm_455",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_1q0fm_467",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_1q0fm_467",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_1q0fm_467",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_1q0fm_467",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_1q0fm_483",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_1q0fm_487",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_1q0fm_491",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_1q0fm_1",
  "refresh": "awsui_refresh_xjuzf_1q0fm_609",
  "root": "awsui_root_xjuzf_1q0fm_631",
  "trigger": "awsui_trigger_xjuzf_1q0fm_643",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_1q0fm_650",
  "trigger-inner-text": "awsui_trigger-inner-text_xjuzf_1q0fm_679"
};
  